import { forwardRef } from 'react'
import { Calendar as CalendarIcon, ChevronUp, ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface DatePickerTriggerProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  displayValue: string
  open: boolean
  disabled?: boolean
  hasError?: boolean
  className?: string
}

export const DatePickerTrigger = forwardRef<HTMLButtonElement, DatePickerTriggerProps>(
  (
    {
      displayValue,
      open,
      disabled = false,
      hasError = false,
      className = '',
      ...rest
    },
    ref
  ) => (
    <Button
      ref={ref}
      type="button"
      variant="ghost"
      disabled={disabled}
      className={`w-full justify-between text-left font-normal border-0 bg-[#F5F5F5] hover:bg-[#F5F5F5] hover:text-gray-900 overflow-hidden ${hasError ? 'border border-red-500' : ''} ${className}`}
      {...rest}
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <CalendarIcon className="h-4 w-4 flex-shrink-0" />
        {displayValue ? <span className="truncate">{displayValue}</span> : null}
      </div>
      <div className="ml-2 flex-shrink-0">
        {open ? (
          <ChevronUp className="h-4 w-4 text-gray-500" />
        ) : (
          <ChevronDown className="h-4 w-4 text-gray-500" />
        )}
      </div>
    </Button>
  )
)
DatePickerTrigger.displayName = 'DatePickerTrigger'
